<script setup lang="ts">
import {tgRbxSupportBot} from "@/constants.js";
import TelegramLogo from "@/Components/Icons/TelegramLogo.vue";
</script>
<template>
    <div class="w-full px-2.5 md:px-0 md:max-w-[640px] m-auto mt-5">
        <div class="mt-5 px-3 py-5 shadow-[4px_4px_12px_0_rgba(0,0,0,0.3)] bg-cyan-200 flex flex-col items-center font-medium rounded-lg">
            <p class="w-full text-center font-['Unbounded'] font-medium text-[18px]">
                {{$t('Get help')}}
            </p>
            <img src="/assets/img/roblox/help.webp" class="my-2.5" alt="help-circle" style="width: 100px; height: 105px;" />
            <a :href="tgRbxSupportBot" target="_blank" class="flex group mt-6 items-center gap-2.5 bg-cyan-500 shadow-[inset_1px_-3px_2px_rgba(0,0,0,0.3)] w-full justify-center py-3 rounded-full font-sans font-medium text-white transition-opacity hover:opacity-60">
                <span class="text-[18px]">{{$t('Telegram support')}}</span>
                <img src="/assets/img/roblox/link-icon.svg" alt="link=icon" style="width: 30px; height: 30px;">
            </a>
        </div>
    </div>
</template>
